import { TypeOfCancer } from '@/components/icons/icon-catch/types';
import { mapCancerType } from './map-cancer-type';

export function normalizeCancerTypeName(cancerType: string) {
  return mapCancerType(cancerType as TypeOfCancer).replace(/_/g, ' ');
}
